let registeredCallback: () => void = null;

const insertSxSV2IntoDomHelper = {
    register: (callback: () => void) => {
        registeredCallback = callback;
    },
    available: () => !!registeredCallback,
    run: () => {
        if (registeredCallback) {
            registeredCallback();
        }
    },
};

export default insertSxSV2IntoDomHelper;
